"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShortDescriptionCardWrapper = exports.ShortDescriptionCard = exports.LongDescriptionCard = exports.Group = exports.CalculatePageLimit = exports.CalculateGroupedEntriesTotal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _trimble_logo = _interopRequireDefault(require("../../images/trimble_logo.png"));
var _checkForExternalLink = _interopRequireDefault(require("../../utils/checkForExternalLink"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/formatSpecialCharText"));
var _generateFocusedImageAlt = _interopRequireDefault(require("../../utils/generateFocusedImageAlt"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _FocusedImage = _interopRequireDefault(require("../FocusedImage/FocusedImage"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const LongDescriptionCard = _ref => {
  let {
    eyebrow,
    header,
    subhead,
    link,
    image,
    summary,
    ariaLabel,
    contentfulId
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "card",
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "thumbnail-container",
    "data-sb-field-path": "image"
  }, image?.focalPointImage?.url ? /*#__PURE__*/_react.default.createElement(_FocusedImage.default, {
    imageSizes: {
      desktop: {
        width: 240,
        height: 240,
        ratio: {
          width: 1,
          height: 1
        }
      },
      tablet: {
        width: 180,
        height: 180,
        ratio: {
          width: 1,
          height: 1
        }
      },
      mobile: {
        width: 160,
        height: 160,
        ratio: {
          width: 1,
          height: 1
        }
      }
    },
    focalPointImage: image?.focalPointImage && image?.focalPointImage,
    alt: (0, _generateFocusedImageAlt.default)(image)
  }) : /*#__PURE__*/_react.default.createElement("img", {
    src: _trimble_logo.default,
    alt: "Trimble Logo",
    className: "fallback-image"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "content-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "header-container"
  }, eyebrow && /*#__PURE__*/_react.default.createElement("div", {
    className: "eyebrow",
    "data-sb-field-path": "eyebrow"
  }, eyebrow), header && /*#__PURE__*/_react.default.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header),
    "data-sb-field-path": "header"
  }), subhead && /*#__PURE__*/_react.default.createElement("div", {
    className: "subtitle",
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(subhead),
    "data-sb-field-path": "subhead"
  })), summary && /*#__PURE__*/_react.default.createElement("div", {
    className: "body-container",
    dangerouslySetInnerHTML: {
      __html: summary
    },
    "data-sb-field-path": "shortSummary"
  }), link?.url && /*#__PURE__*/_react.default.createElement("div", {
    className: "card-link-container",
    "data-sb-field-path": "link"
  }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    to: link?.url,
    ariaLabel: ariaLabel,
    className: (0, _checkForExternalLink.default)(link?.url) ? "card-link-external" : "card-link"
  }, link?.text))));
};
exports.LongDescriptionCard = LongDescriptionCard;
const ShortDescriptionCardWrapper = _ref2 => {
  let {
    link,
    ariaLabel,
    contentfulId,
    children
  } = _ref2;
  return link && link?.url ? /*#__PURE__*/_react.default.createElement("div", {
    className: "card",
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    to: link?.url,
    ariaLabel: ariaLabel
  }, children)) : /*#__PURE__*/_react.default.createElement("div", {
    className: "card card-no-link",
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, children);
};
exports.ShortDescriptionCardWrapper = ShortDescriptionCardWrapper;
const ShortDescriptionCard = _ref3 => {
  let {
    header,
    link,
    category,
    role,
    ariaLabel,
    contentfulId
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(ShortDescriptionCardWrapper, {
    link: link,
    ariaLabel: ariaLabel,
    contentfulId: contentfulId
  }, header && /*#__PURE__*/_react.default.createElement("div", {
    className: "heading-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `heading ${link && link?.url && (0, _checkForExternalLink.default)(link?.url) ? "has-link-external" : link && link?.url ? "has-link" : ""}`,
    dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header),
    "data-sb-field-path": "header"
  })), (category || role) && /*#__PURE__*/_react.default.createElement("div", {
    className: "subhead-container"
  }, category && /*#__PURE__*/_react.default.createElement("div", {
    className: "entry industry-category",
    "data-sb-field-path": "industryOrCategory"
  }, category), role && /*#__PURE__*/_react.default.createElement("div", {
    className: "entry role",
    "data-sb-field-path": "role"
  }, role)));
};
exports.ShortDescriptionCard = ShortDescriptionCard;
const Group = _ref4 => {
  let {
    entries,
    title
  } = _ref4;
  return entries?.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: "cards-group"
  }, title && /*#__PURE__*/_react.default.createElement("div", {
    className: "group-heading",
    "data-sb-field-path": "groupingCategory"
  }, title), entries?.length > 1 ? entries.map((entry, index) => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: `${entry}-${index}`
  }, /*#__PURE__*/_react.default.createElement(ShortDescriptionCard, {
    header: entry?.header,
    link: entry?.link,
    category: entry?.industryCategory,
    role: entry?.role,
    ariaLabel: entry?.customAriaLabel,
    contentfulId: entry?.contentfulId
  }))) : /*#__PURE__*/_react.default.createElement(ShortDescriptionCard, {
    header: entries[0]?.header,
    link: entries[0]?.link,
    category: entries[0]?.industryCategory,
    role: entries[0]?.role,
    ariaLabel: entries[0]?.customAriaLabel,
    contentfulId: entries?.[0].contentfulId
  })) : null;
};
exports.Group = Group;
const CalculatePageLimit = function (totalItems) {
  let itemLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  return Math.ceil(totalItems / itemLimit);
};
exports.CalculatePageLimit = CalculatePageLimit;
const CalculateGroupedEntriesTotal = groups => {
  // Use this function in case we ever want to add functionality for paginating grouped entries
  let total = 0;
  groups.forEach(group => {
    total = total + group.entries.length;
  });
  return total;
};
exports.CalculateGroupedEntriesTotal = CalculateGroupedEntriesTotal;